module.exports = __webpack_public_path__ + "img/6d33a34.jpg";